import { render } from "./LawyerJobMemberToggleCard.vue?vue&type=template&id=bdc855f6&scoped=true"
import script from "./LawyerJobMemberToggleCard.vue?vue&type=script&lang=js"
export * from "./LawyerJobMemberToggleCard.vue?vue&type=script&lang=js"

import "./LawyerJobMemberToggleCard.vue?vue&type=style&index=0&id=bdc855f6&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdc855f6"]])

export default __exports__